import { TopicId } from '~/dashboard/utils/learningPath.utils'

export enum RewardAlt {
  RED_ALT = 'gemRedAlt',
  GREEN_ALT = 'gemGreenAlt',
  BLUE_ALT = 'gemBlueAlt',
  KUDOS = 'kudos',
}

export enum GEM_TYPE {
  RED = 'red',
  GREEN = 'green',
  BLUE = 'blue',
}

export enum QUEST_REWARD {
  RED_GEM = 'red',
  GREEN_GEM = 'green',
  BLUE_GEM = 'blue',
  KUDOS = 'kudos',
}

export enum QUEST_TYPE {
  ESSENTIALS = 'essentials',
  BOOTCAMP = 'bootcamp',
  ADVANCED = 'encyclopedia',
  QUIZ = 'mappingQuiz',
}

export enum QUEST_TITLES {
  ESSENTIALS = 'Math Essential',
  BOOTCAMP = 'Video Crash Course',
  ADVANCED = 'Encylopedia',
  QUIZ = 'mappingQuiz',
}

export interface Quest {
  title: string
  taskId: string
  path: string
  reward: QuestReward
  topics?: string[]
  taskCategory: string
  mathTopicCategory: TopicId
  icon?: string
  topicTitle?: string
  progress: number
  thumbnail: { srcKey: string }
  levels: Level[]
  summary: questSummary
  whyVideo: LevelVideo | null
  isLastVisited: boolean
  mathPreview?: string
}

interface questSummary {
  bossBattleUrl: string
  completedBossBattlesCount: number
  totalBossBattlesCount: number
  isBossBattleLastVisited: boolean
  isBossDefeated?: boolean
}

export interface Level {
  activities: LevelActivity[]
  isCompleted: boolean
  name: string
  videos: LevelVideo[]
  isChestOpened: boolean
}

export interface LevelActivity {
  id: number
  chestsCount: number
  completedChestsCount: number
  isLastVisited: boolean
  path: string
}

export interface LevelVideo {
  isLastVisited: boolean
  isWatched: boolean
  path: string
  title: string
}

export interface QuestReward {
  gems: number
  kudos: number
  xp: number
}

export interface QuestState {
  questName: string
  questRewards: QuestReward
  showCompletedQuestModal: boolean
}

export interface DummyDataImport {
  dummyData: DummyData
  questColor: string
  secondaryBgColor: string
  secondaryTxtColor: string
}

export enum DummyTitle {
  MULT_TITLE = 'dummyData.mult.title',
  ALGEBRA_TITLE = 'dummyData.algebra.title',
}
export enum DummyText {
  MULT_DESC = 'dummyData.mult.description',
  ALGEBRA_DESC = 'dummyData.algebra.description',
}

export interface DummyData {
  title: DummyTitle.MULT_TITLE | DummyTitle.ALGEBRA_TITLE
  description: DummyText.MULT_DESC | DummyText.ALGEBRA_DESC
  icon: string
}

export interface GetQuestsResponse {
  currentQuests: Quest[]
  completedTasks: Quest[]
  missingMappingQuiz?: boolean
}

export interface BadgeData {
  id: number
  featureId: string
  order: number
  imageOutlinePath: string
  metadata: { gymCategory: string; subjectId: string }
  subBadges: SubBadges[]
  isComplete: boolean
}

export interface SubBadges {
  featureId: string
  order: number
  imagePath: string
  parentBadgeId: number
  imageOutlinePath: string
  mainBadgeImagePartPath: string
  metaData: { moduleNumber: string; name: string }
  isComplete: boolean
}
